/**
 * Posts Infinite Scroll Setup
 *
 * Posts list adapter for shared infinite scroll.
 */

import { InfiniteScrollSetup } from "../../components/infinite-scroll/infinite-scroll-setup";
import { Roles } from "../../constants/roles";
import { postsInfiniteScrollForm } from "./posts-infinite-scroll-form";
class PostsInfiniteScrollSetup {
    private static readonly postsListSelector = `[data-list-type="${Roles.POSTS_LIST}"]`;

    private static readonly postCardSelector = `[data-role="${Roles.POST_CARD}"]`;

    public static appendPostDetailHidden(doc: Document, currentDoc: Document): void {
        const destination = postsInfiniteScrollForm.getContainer(currentDoc);
        if (!(destination instanceof HTMLElement)) return;

        const hiddenNodes = postsInfiniteScrollForm.getHiddenPostDetails(doc);
        hiddenNodes.forEach((node) => {
            const postKey = node.dataset.postId;
            if (!postKey) return;

            const existing = postsInfiniteScrollForm.getHiddenPostDetailById(currentDoc, postKey);
            if (existing) return;

            destination.appendChild(node);
        });
    }

    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLElement)) return;
        if (!root.matches(this.postsListSelector)) return;

        InfiniteScrollSetup.init(root, {
            listSelector: this.postsListSelector,
            itemSelector: this.postCardSelector,
            paginationSelector: ".pagination-nav",
            nextLinkSelector: 'a[aria-label="Next page"]',
            rootMargin: "320px 0px",
            hidePaginationOnMobile: true,
            appendExtras: (doc: Document, currentDoc: Document) => {
                this.appendPostDetailHidden(doc, currentDoc);
            },
        });
    }
}

export { PostsInfiniteScrollSetup };
